import { render, staticRenderFns } from "./InspectionInput.vue?vue&type=template&id=c52483f8&"
import script from "./InspectionInput.vue?vue&type=script&lang=js&"
export * from "./InspectionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports